/**
 * Background Image Service
 *
 * Simple random background selection. Update the array when adding new images.
 */

class BackgroundImageService {
  constructor() {
    this.basePath = '/assets/images/gears/bkgs/';
    // Add all your background images here
    this.backgroundImages = [
      'bkg-4arm-pipes.jpg',
      'bkg-airship-interior1.jpg',
      'bkg-blue-portal.jpg',
      'bkg-blue-tube.jpg',
      'bkg-complicated-realitic-machine.jpg',
      'bkg-deep-boiler.jpg',
      'bkg-flame-boiler.jpg',
      'bkg-legged-boiler.jpg',
      'bkg-pipe-warehouse.jpg',
      'bkg-plasma.jpg',
      'bkg-tiefighter.jpg',
      'bkg-vending-machine-anime.jpg',
      'busy-room.jpg',
      'giant-hose-device.jpg',
      'multi-pipe-guy.jpg',
      'pipe-glass-wall.jpg',
    ];
  }

  /**
   * Get a random background image path
   * @returns {string} Full path to a random background image
   */
  getRandomBackground() {
    const randomIndex = Math.floor(Math.random() * this.backgroundImages.length);
    return `${this.basePath}${this.backgroundImages[randomIndex]}`;
  }

  /**
   * Get all available background images
   * @returns {Array<string>} Array of background image filenames
   */
  getAllBackgrounds() {
    return [...this.backgroundImages];
  }

  /**
   * Add a new background image to the service
   * @param {string} filename - The filename of the new background image
   */
  addBackgroundImage(filename) {
    if (!this.backgroundImages.includes(filename)) {
      this.backgroundImages.push(filename);
    }
  }

  /**
   * Remove a background image from the service
   * @param {string} filename - The filename of the background image to remove
   */
  removeBackgroundImage(filename) {
    const index = this.backgroundImages.indexOf(filename);
    if (index > -1) {
      this.backgroundImages.splice(index, 1);
    }
  }

  /**
   * Get the total number of available background images
   * @returns {number} Number of background images
   */
  getBackgroundCount() {
    return this.backgroundImages.length;
  }
}

// Create and export a singleton instance
const backgroundImageService = new BackgroundImageService();
export default backgroundImageService;
